export default {
  enums: [
    { id: 'CEM' },
    { id: 'SELF_MADE' },
  ]
};